import { Checkbox, DataSource, ExcludableTextbox, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePendingPayAdjustmentsReport extends Layout {
    checkboxIncludeSettlementPayAdjustments: Checkbox;
    dateboxCutoffDate: Textbox;
    excludabletextboxGLAccounts: ExcludableTextbox;
    excludabletextboxPayAdjustCodes: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    panelReportType: Panel;
    sourceOfficePendingPayAdjustments: DataSource;
    switchReportType: Switch;
    textboxGroupBy: Textbox;
    textboxPayeeType: Textbox;
}
